import React, { Component } from 'react';
import { RefreshState } from '../../../redux/reducers/RefreshReducer';
import RefreshButton from '../../atoms/RefreshButtom';
import Cookies from 'js-cookie';
import moment from 'moment';
import { GASpotEventState } from '../../organisms/NegotiationCountList';

export interface InquiryDateHandler {
  currentRefresh: RefreshState;
}

export interface InquiryDateProps extends InquiryDateHandler {
  screenId: string;
  jobDateTime?: string;
  isLoading?: boolean;
  error?: any;
  disableSystemError?: boolean;
  gaSpotEvent?: GASpotEventState;
  customRefresh?: () => void;
}

class InquiryDate extends Component<InquiryDateProps, {}> {
  constructor(props: InquiryDateProps) {
    super(props);
    this.state = {};
  }

  refreshPage = () => {
    this.props.currentRefresh.refresh();
  };

  getInquiryDate(jobDateTime?: string): string {
    if (jobDateTime) {
      const dStr = jobDateTime.replace(/^([0-9]{4})([0-9]{2})([0-9]{2})([0-9]{2})([0-9]{2})([0-9]{2})$/, '$1/$2/$3 $4:$5:$6');
      const d = new Date(dStr);
      if (!isNaN(d.getTime())) {
        return moment(dStr).format('YYYY年MM月DD日 HH:mm:ss');
      }
    }
    return ' -- ';
  }

  render() {
    const { isLoading, error, disableSystemError, gaSpotEvent, customRefresh } = this.props;

    if (!isLoading && error && !disableSystemError) {
      Cookies.remove('sessionId');
      Cookies.remove('userInfo');
      window.location.replace('/sorry');
      return <></>;
    }
    return (
      <div className='u-float-right' data-testid-e2e='display-snapshot-datetime'>
        <span className='u-mh4 u-text-middle'>
          {isLoading && '読み込み中'}
          <>{this.getInquiryDate(this.props.jobDateTime)}時点</>
        </span>
        <RefreshButton onclick={customRefresh ? customRefresh : this.refreshPage} isLoading={isLoading} gaSpotEvent={gaSpotEvent} />
      </div>
    );
  }
}

export default InquiryDate;
